import React from "react";
import { Formik } from "formik";
import { splashScreenValidationSchema } from "../../../../utils/validationSchemas/MasterDataSchema";
import CustomImageUpload from "../../../components/Forms/CustomInputs/CustomImageUpload";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";

const SplashScreenForm = ({ initialValues, handleFormSubmit }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={splashScreenValidationSchema}
            onSubmit={(values, ...rest) => {
                return handleFormSubmit(values, ...rest, 'splash')
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <CustomImageUpload
                            fieldName="splash_screen.image"
                            value={values?.splash_screen?.image}
                            error={errors?.splash_screen?.image}
                            label={"Upload mage (9:16 / e.g. 450px X 800px)"}
                            imageRatio="9_16"
                            classes={"col-md-12"}
                            handleBlur={handleBlur}
                            inputType={"text"}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue} />

                        <CustomTextbox
                            fieldName="splash_screen.title"
                            value={values?.splash_screen?.title}
                            error={errors?.splash_screen?.title}
                            label={"Title"}
                            classes={"col-md-12"}
                            handleBlur={handleBlur}
                            inputType={"text"}
                            handleChange={handleChange}
                        />
                        <CustomTextbox
                            fieldName="splash_screen.subtitle"
                            value={values?.splash_screen?.subtitle}
                            error={errors?.splash_screen?.subtitle}
                            label={"SubTitle"}
                            classes={"col-md-12"}
                            handleBlur={handleBlur}
                            inputType={"text"}
                            handleChange={handleChange}
                        />
                        {/* <CustomTextbox
                          fieldName="splash_screen.button_text"
                          value={values?.splash_screen?.button_text}
                          error={errors?.splash_screen?.button_text}
                          label={"Button Text"}
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"text"}
                          handleChange={handleChange}
                        /> */}
                    </div>

                    <div className="float-end">
                        <button
                            type="submit"
                            className="btn me-2 btn-primary"
                            disabled={isSubmitting}
                        >
                            Save
                        </button>
                    </div>
                    {/* <button className="btn btn-danger light">Cancel</button> */}
                </form>
            )}
        </Formik>
    )
}

export default SplashScreenForm